import { AccountPlaceholderPage } from "@/components/account/account-placeholder-page"

export default function MinhaContaAssinaturasPage() {
  return (
    <AccountPlaceholderPage
      description='Esta area pode reunir assinaturas ativas, renovacoes, historico de cobranca recorrente e opcoes para gerenciar cada plano.'
      title='Assinaturas'
    />
  )
}
